import { AuthUser } from '@app/core/types/users';
import { UserRole } from '@mi-front/core';
import debugFn from 'debug';
import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router';
import { useImpersonation } from './useImpersonationStore';

export const debug = debugFn('auth:impersonation');

/**
 * Hook that requires that if an admin is logged in, a user to
 * impersonate must be selected before accessing any screen
 */

export function useSuperadminLock(user?: AuthUser) {
  const { impersonatedUser } = useImpersonation();
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    if (!user) {
      return;
    }

    // Only redirect if user is superadmin, no impersonated user is configured,
    // and we're not already on the admin page to avoid infinite redirect
    if (
      user.role === UserRole.SUPERADMIN &&
      !impersonatedUser &&
      location.pathname !== '/settings/impersonation'
    ) {
      debug('No impersonated user selected, redirecting to impersonation screen');
      history.push('/settings/impersonation');
    }
  }, [user, impersonatedUser, history, location.pathname]);
}
